var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "product-aside-description",
    domProps: { innerHTML: _vm._s(_vm.product.descriptionHtml) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }